import React, { useState, useEffect } from 'react';
import { X, Save, Percent, FileText, Plus, Trash2 } from 'lucide-react';
import axios from 'axios';
import toast from 'react-hot-toast';

const TaxCategoryModal = ({ isOpen, onClose, orgId }) => {
  const [taxes, setTaxes] = useState([]);
  const [newTax, setNewTax] = useState({ taxid: '', description: '', taxrate: 0 });
  
  // ????? ??? Org ID: ?? ?? ??? ?? ??? props ??? ?? ??? session
  const session = JSON.parse(localStorage.getItem('user') || '{}');
  const activeOrgId = orgId || session.org_id;

  useEffect(() => {
    if (isOpen && activeOrgId) {
        fetchTaxes();
    }
  }, [isOpen, activeOrgId]);

  const fetchTaxes = async () => {
    try {
      const res = await axios.get(`/api/tax-categories/${activeOrgId}`);
      setTaxes(res.data);
    } catch (err) {
      console.error("Fetch Taxes Error:", err);
    }
  };

  const handleSave = async () => {
    if (!newTax.taxid) return toast.error("Tax ID is required");
    if (newTax.taxrate < 0) return toast.error("Invalid Tax Rate");

    try {
      // ??????? ???: ???? ???? org_id ?????? ?? ?? ???????? ?????? ?? ??? payload
      const payload = { 
        taxid: newTax.taxid.toUpperCase(), 
        description: newTax.description || newTax.taxid,
        taxrate: parseFloat(newTax.taxrate),
        org_id: activeOrgId // ?????? ?? ????? org_id
      };

      await axios.post('/api/tax-categories/save', payload);
      
      toast.success("Tax Category Saved");
      setNewTax({ taxid: '', description: '', taxrate: 0 });
      fetchTaxes();
    } catch (err) { 
      toast.error("Save Failed: " + (err.response?.data?.detail || "Server Error")); 
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[8000] flex items-center justify-center bg-black/60 backdrop-blur-sm">
      <div className="bg-white w-[500px] rounded-lg shadow-2xl flex flex-col overflow-hidden border-t-4 border-t-blue-900">
        {/* Header */}
        <div className="bg-slate-50 p-4 border-b flex justify-between items-center">
          <div className="flex flex-col">
             <h2 className="font-black text-blue-900 uppercase flex items-center gap-2">
                <Percent size={16}/> Tax Management
             </h2>
             <span className="text-[8px] text-gray-400 font-bold uppercase">Org Context: {activeOrgId}</span>
          </div>
          <button onClick={onClose} className="hover:text-red-600 transition-colors"><X size={18}/></button>
        </div>
        
        <div className="p-6 space-y-4">
          {/* Input Section */}
          <div className="grid grid-cols-3 gap-2 bg-blue-50 p-3 rounded-md border border-blue-100 items-end">
            <div className="flex flex-col gap-1">
                <label className="text-[8px] font-black text-blue-400 uppercase">Tax ID</label>
                <input placeholder="VAT15" className="p-2 border rounded font-black uppercase text-xs outline-none focus:border-blue-900" 
                    value={newTax.taxid} onChange={e => setNewTax({...newTax, taxid: e.target.value})} />
            </div>
            <div className="flex flex-col gap-1">
                <label className="text-[8px] font-black text-blue-400 uppercase">Rate %</label>
                <input placeholder="15" type="number" className="p-2 border rounded font-black text-xs outline-none focus:border-blue-900" 
                    value={newTax.taxrate} onChange={e => setNewTax({...newTax, taxrate: e.target.value})} />
            </div>
            <button onClick={handleSave} className="bg-blue-900 text-white font-black rounded py-2.5 flex items-center gap-1 justify-center hover:bg-black transition-all">
                <Plus size={14}/> Add
            </button>
          </div>

          {/* Table Section */}
          <div className="max-h-60 overflow-y-auto border rounded shadow-inner">
            <table className="w-full text-left text-[10px]">
              <thead className="bg-gray-100 font-black text-gray-400 uppercase sticky top-0">
                <tr>
                    <th className="p-3 border-r">Tax ID</th>
                    <th className="p-3 border-r text-center">Rate %</th>
                    <th className="p-3 text-right">Action</th>
                </tr>
              </thead>
              <tbody>
                {taxes.map((t, i) => (
                  <tr key={i} className="border-b hover:bg-blue-50 font-bold transition-colors">
                    <td className="p-3 text-blue-900 border-r">{t.taxid}</td>
                    <td className="p-3 text-red-600 text-center border-r font-mono">{t.taxrate}%</td>
                    <td className="p-3 text-right">
                        <button className="text-gray-300 hover:text-red-600 transition-colors"><Trash2 size={12}/></button>
                    </td>
                  </tr>
                ))}
                {taxes.length === 0 && (
                    <tr><td colSpan="3" className="p-10 text-center text-gray-300 italic uppercase">No Taxes Found for this Org</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TaxCategoryModal;